<template>
  <div class="content-text">
    <slot />
  </div>
</template>

<script>
export default {
    name: 'ContentText',
}
</script>

<style lang="scss" scoped>
div.content-text {
    padding: 1rem;
    text-align: left;
}
</style>